<h3 class="__header">Create New Floor</h3>
<span class="__input-label">Floor Name</span>
<input awairInput
       type="text"
       autocomplete="off"
       (keyup.enter)="onCreate()"
       (ngModelChange)="onChangeName($event)"
       required ngModel>

<div class="__btn-group">
  <awair-button class="__btn-gray" [hostDisabled]="isLoading" (btnClick)="onCancel()">Cancel</awair-button>
  <awair-button class="__btn-blue" [hostDisabled]="isLoading" (btnClick)="onCreate()">Create</awair-button>
</div>
